import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchEffectivenessArgs,
  FetchActivityLogArgs,
} from '../api/types/statsEntries.types';

import {
  fetchEffectiveness,
  fetchActivityLog,
} from '../api/activityLogStats.api';

export const statsActivityLogQueryKeys = createQueryKeys('statsActivityLog', {
  fetchActivityLog: (args: FetchActivityLogArgs = {}) => ({
    queryFn: () => fetchActivityLog(args),
    queryKey: [args],
  }),
  fetchEffectiveness: (args: FetchEffectivenessArgs = {}) => ({
    queryFn: () => fetchEffectiveness(args),
    queryKey: [args],
  }),
});
